import { manageSubscriptionsStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

manageSubscriptionsStyles.manageSubscriptionsTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        color: ${getColor("text.main")};
        margin-top: 30px;
    `,
};
manageSubscriptionsStyles.manageSubscriptionsCheckbox = {
    typographyProps: {
        css: css`
            margin-left: 10px;
            color: ${getColor("text.main")};
        `,
    },
};
